PJQ.views.files.OrderPrintsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Modal-Order-Prints'),
        minWidth: '600px',
        maxWidth: '1400px',
        isSelectRecipients: false,
        onOrderPlaced: null,
        mode: PJQ.constants.files.modes.PRINT,
        subTemplates: {
            orderFolderSelector: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'ordering-folder-selector'),
            orderCalculatedItems: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'ordering-calculated-items')
        },
    },
    events: {
        'change .input-select-recipients': 'selectRecipientsChanged',
        'click .btn-close': 'onCancel',
        'click .btn-save': 'onSave',
        'click .ordering-folder': 'selectFolder',
        'click .select-file': 'fileSelectChanged',
        'click .order-jump-step': 'goToStep',
        'click .view-file': 'viewFile',
        'click .delete-recipient': 'deleteRecipient',
        'click .edit-recipient': 'editRecipient',
        'click .select-all-files': 'selectAllFiles'
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.project == null || PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId');
        this.mode = this.options.mode ? this.options.mode : 'PRINTS';
        this.options.maxWidth = this.mode === PJQ.constants.files.modes.ALT_PRINT || (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === "busy") ? '1400px' : '600px';

        if (this.mode === PJQ.constants.files.modes.DOWNLOAD && this.options.files != null) {
            // Need this.options.files to be an array.
            if(PJQ.helpers.objectHelpers.refinedType(this.options.files, true) === 'backboneCollection'){
                this.options.files = this.options.files.models;
            }
            if(PJQ.helpers.objectHelpers.refinedType(this.options.files, true) === 'backboneModel'){
                this.options.files = [this.options.files];
            }
            this.options.files = _.filter(this.options.files, function (file) {
                if (file) {
                    // There are cases of Non-Backbone models being passed through.
                    if(PJQ.helpers.objectHelpers.refinedType(file, true) === 'backboneModel') {
                        return !file.get('isFolder')
                    }
                    else{
                        return !file.isFolder
                    }
                }
            }, this)
        }

        if (this.options.files == null) {
            this.options.files = [];
        } else if (PJQ.helpers.objectHelpers.refinedType(this.options.files) !== 'array') {
            this.options.files = [this.options.files];
        }

        if (this.options.isAdmin && _.size(this.options.recipients) > 0) {
            this.options.isSelectRecipients = true;
        }

        // Fetch any updated preferences to make sure all are up to date
        if (PJQ.app.session.contact != null) {
            PJQ.app.session.preferences.fetch();
            if (!PJQ.app.session.contact.isFetched) {
                PJQ.app.session.contact.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this)
                });
            }
        } else if (PJQ.app.session.user != null) {
            PJQ.app.session.preferences.fetch();
            if (!PJQ.app.session.user.isFetched) {
                PJQ.app.session.user.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this)
                });
            }
        }
    },
    beforeRender: function () {
        this.createOrder();
    },
    selectRecipientsChanged: function () {
        this.options.isSelectRecipients = this.$('.input-select-recipients').prop('checked');
        this.render();
    },
    createOrder: function () {
        if (this.model == null) {
            this.model = new PJQ.models.files.Order({
                project: PJQ.app.session.project != null ? PJQ.app.session.project : this.options.project,
                description: "",
                poNumber: "",
                notes: "",
                largeFormatBinding: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_BINDING_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_BINDING_TYPE) : "STAPLED",
                largeFormatPaperType: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PAPER_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PAPER_TYPE) : "WHITE BOND",
                largeFormatQuantity: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PRINT_SIZE) ? (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PRINT_SIZE) === PJQ.constants.ordering.paperSize.FULL ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_QUANTITY) : 0 ) : 0,
                smallFormatBinding: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_BINDING_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_BINDING_TYPE) : "STAPLED",
                smallFormatQuantity: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_QUANTITY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_QUANTITY) : 0,
                smallFormatPaperType: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_PAPER_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_PAPER_TYPE) : "WHITE BOND",
                halfSizeQuantity: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PRINT_SIZE) ? (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PRINT_SIZE) === PJQ.constants.ordering.paperSize.HALF ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_QUANTITY) : 0 ) : 0,
                cdQuantity: 0,
                shippingSpeed: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_DELIVER_BY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_DELIVER_BY) : "Next Day (Morning)",
                files: this.options.files
            });
        }

        if (this.options.isAdmin && this.options.isSelectRecipients) {
            this.model.recipients = new PJQ.collections.contacts.Contacts(this.options.recipients != null ? this.options.recipients : []);
        } else {
            this.model.recipients = null;
            let contact;
            if (PJQ.app.session.contact != null) {
                contact = PJQ.app.session.contact;
            } else if (PJQ.app.session.user != null) {
                contact = PJQ.app.session.user;
            } else {
                contact = new PJQ.models.contacts.Contact();
            }
            this.model.set({
                notifyEmail: contact.get('email'),
                billingCompanyName: contact.get('companyName'),
                billingContactName: contact.get('contactName'),
                billingPhone: contact.get('phone'),
                billingPhoneExtension: contact.get('phoneExtension'),
                billingAddress1: contact.get('address1'),
                billingAddress2: contact.get('address2'),
                billingCity: contact.get('city'),
                billingState: contact.get('state'),
                billingZip: contact.get('zip'),
                billingCountry: contact.get('country') ? contact.get('country') : 'US',
                isDownload: this.mode === PJQ.constants.files.modes.DOWNLOAD
            });
        }
    },
    renderData: function () {
        return {
            isAdmin: this.options.isAdmin,
            isSelectRecipients: this.options.isSelectRecipients,
            mode: this.mode,
            model: this.model,
            price: this.price
        };
    },
    afterRender: function () {
        if (this.model != null) {
            if (this.options.isAdmin && this.options.isSelectRecipients) {
                new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.order-recipients'),
                    context: PJQ.app.session.project != null ? PJQ.constants.contacts.contexts.PARTICIPANTS : PJQ.constants.contacts.contexts.CONTACTS,
                    selectedContact: this.model.recipients.models,
                    showSelectorAddress: true,
                    isSingleChoice: false,
                    onChange: _.bind(function (selectedContacts) {
                        this.model.recipients.reset(selectedContacts);
                    }, this)
                });
            } else {
                this.statePicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.contact-edit-state'),
                    noneSelectedText: 'Select Value',
                    defaultValue: this.model.get('billingState'),
                    onChange: _.bind(function (value) {
                        this.model.set('billingState', value.toUpperCase());
                    }, this)
                });
                this.countryChanged();

                new PJQ.inputs.Selectpicker({
                    el: this.$('.contact-edit-country'),
                    noneSelectedText: 'Select Value',
                    defaultValue: _.size(this.model.get('billingCountry')) > 0 ? this.model.get('billingCountry').toLowerCase() : 'us',
                    onChange: _.bind(function (value) {
                        this.model.set('billingCountry', value.toUpperCase());
                        this.model.set('billingZip', '');
                        this.model.set('billingState', '');
                        this.statePicker.setValue('');
                        this.$('.contact-edit-zip').val('');
                        this.countryChanged();
                    }, this)
                });

                PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-phone'));
                PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-fax'));
                PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-cell'));
            }
            new PJQ.views.files.FileSelectInput({
                el: this.$('.order-files'),
                project: this.model.project,
                selectedFiles: this.model.files,
                collection: this.options.collection,
                ignoreFolders: true,
                selectorOptions: {
                    header: 'Select files to order',
                    confirmButton: 'Update Order'
                },
                isShowChangeButton: true,
                onChange: _.bind(function (selectedFiles) {
                    this.model.files = selectedFiles;
                    this.calculateCost();
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.order-lf-paper'),
                defaultValue: this.model.get('largeFormatPaperType'),
                onChange: _.bind(function (value) {
                    this.model.set('largeFormatPaperType', value.toUpperCase());
                }, this)
            });
            new PJQ.inputs.Selectpicker({
                el: this.$('.order-lf-binding'),
                defaultValue: this.model.get('largeFormatBinding'),
                onChange: _.bind(function (value) {
                    this.model.set('largeFormatBinding', value.toUpperCase());
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.order-sf-paper'),
                defaultValue: this.model.get('smallFormatPaperType'),
                onChange: _.bind(function (value) {
                    this.model.set('smallFormatPaperType', value.toUpperCase());
                }, this)
            });
            new PJQ.inputs.Selectpicker({
                el: this.$('.order-sf-binding'),
                defaultValue: this.model.get('smallFormatBinding'),
                onChange: _.bind(function (value) {
                    this.model.set('smallFormatBinding', value.toUpperCase());
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.order-shipping-speed'),
                defaultValue: this.model.get('shippingSpeed'),
                onChange: _.bind(function (value) {
                    this.model.set('shippingSpeed', value.toUpperCase());
                }, this)
            });

            if (this.price == null && this.mode === PJQ.constants.files.modes.DOWNLOAD) {
                this.calculateCost();
            }

            if(this.mode === PJQ.constants.files.modes.ALT_PRINT){
                this.goToStep(1)
                this.renderFolderPicker();
                this.renderAddressBook();
            }

            new PJQ.Binder(this.$el, this.model);
        } else {
            new PJQ.Loader(this.$('.order-loading'));
        }
    },
    deleteRecipient: function(e){
        let target = $(e.currentTarget),
        contactId = target.closest('.card-body').data('id');

    this.model.recipients.remove(contactId);
    this.calculateCost();
    },
    editRecipient: function(e){
        let target = $(e.currentTarget),
            contactId = target.closest('.card-body').data('id');

        new PJQ.views.contacts.BaseEditContactModal({
            model: this.model.recipients.get(contactId),
            onSave: _.bind(function () {
                this.calculateCost();
            }, this)
        });
    },
    selectAllFiles: function(e){
        let isChecked = $(e.currentTarget).prop('checked'),
            fileSelects = this.$('.select-file');

        if(isChecked){
            this.model.files = _.union(this.model.files, this.selectedFolderFiles);
        }
        else{
            _.each(this.selectedFolderFiles, function(file){
                this.model.files = _.without(this.model.files, file);
            }, this)
        }

        fileSelects.prop('checked', isChecked);

        this.$('.order-selected-file-count').text(this.model.files.length);
        this.$('.step-1-continue').attr('disabled', !_.size(this.model.files) > 0);
    },
    viewFile: function(e){
        let target = $(e.currentTarget),
            row = this.filesTable.getRow(target.closest('tr')),
            file = row.data();

        if (file.isImage()) {
            PJQ.app.view.renderPhotoViewer({
                model: file,
                canDownload: false,
                canDelete: false
            });
        }
        else if (file.canRender()) {
            new PJQ.views.files.FileViewer({
                model: file,
                isDisableDownload: true
            });
        }
    },
    renderFolderPicker: function(selectedFolder){
        let fnRender = _.bind(function(){
            this.folders = _.filter(this.attachments.models, function (attachment) {
                // let isStartLevel = false;
                // if(attachment.get('isFolder') && attachment.get('entryId') !== -1){
                //     let parent = this.attachments.get(attachment.get('folderId'));
                //     if(parent){
                //         isStartLevel = parent.get('entryId') === -1 || parent.get('folderId') === 0;
                //     }
                // }
                let isStartLevel = attachment.get('entryId') === -1 || attachment.get('folderId') === 0;
                return isStartLevel && _.size(attachment.getFolderAttachments(true, {
                    hideFolders: true
                })) > 0;
            }, this);

            if (selectedFolder) {
                this.selectedFolder = _.find(this.attachments.models, function (folder) {
                    return folder.id === selectedFolder;
                })
            }
            else {
                this.selectedFolder = _.sortBy(_.filter(this.attachments.models, (folder) => { return folder.get('isFolder') && folder.get('folderId') < 0 }), (folder) => { return folder.get('entryId') })[0];
            }

            if(this.selectedFolder == null){
                this.selectedFolder = this.folders[0];
            }

            if(this.selectedFolder){
                this.selectedFolderFiles = _.filter(this.attachments.models, function (attachment) {
                    return attachment.get('folderId') === this.selectedFolder.get('entryId') && !attachment.get('isFolder');
                }, this)
            }

            let templateData = {
                models: this.folders,
                selectedFolder: this.selectedFolder
            }
            this.renderSubTemplate(false, this.options.subTemplates.orderFolderSelector, this.$('.file-folder-selector'), templateData);
            this.renderFilesTable();
        }, this);
        if(this.attachments == null || this.folders == null) {
            this.options.project.fetchAttachments({
                isShared: true,
                isPrivate: false,
                forceRecursive: true
            }, _.bind(function (attachments) {
                this.attachments = attachments;
                fnRender();
            }, this))
        }
        else{
            fnRender();
        }
    },
    renderAddressBook: function(){
        this.addressBookView = new PJQ.views.addressbook.AddressBook({
            el: this.$('.address-book'),
            selectionMode: PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT,
            disabledContacts: [],
            disabledContactGroups: null,
            onSelection: _.bind(function (contactsAll, contactsNoGroup, contactGroups) {
                this.$('.order-selected-contact-count').text(contactsAll.length);
                this.$('.step-2-continue').attr('disabled', !contactsAll.length > 0);
                this.selectedRecipients = contactsAll;
            }, this)
        });
    },
    renderFilesTable: function () {
        this.filesTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".file-selector-table"),
            data: this.selectedFolderFiles,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Folder contains no files'
            },
            pageLength: 50,
            onRowDoubleClick: _.bind(function (row) {

            }, this),
            columns: [
                {
                    "columnData": '',
                    "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-files" /><div class="state"><label class="wd-0">&nbsp;</label></div></div>',
                    "width": "20px",
                    "data": "null",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(this.renderFileSelect, this)
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": true
                },
                {
                    "title": "Folder",
                    "data": "",
                    "orderable": true,
                    "render": _.bind(function (data, a, b) {
                        return this.selectedFolder.get('name');
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        if(row.canRender() || row.isImage()){
                            return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info view-file ht-30p wd-35p ml-1 fs-14"><span class="fal fa-eye"></span></button></div>';
                        }
                        else{
                            return '';
                        }
                    }, this)
                }
            ]
        });
    },
    selectFolder: function(e){
        let target = $(e.currentTarget);
        this.renderFolderPicker(target.data('id'));
    },
    renderFileSelect: function (data, type, row) {
        let isSelected = _.find(this.model.files, function(file){
            return file.get('entryId') === row.get('entryId')
        }, this) != null

        this.manageSelectAllButtonState();

            return ('<div class="text-align-center"><div class="pretty p-default p-curve fs-22 m-0">' +
                '<input type="checkbox"' + (isSelected  ? ' checked ' : '') + ' class="select-file' + '" />' +
                '<div class="state p-primary"><label class="wd-0">&nbsp;</label></div>' +
                '</div></div>');
    },
    fileSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            row = this.filesTable.getRow(tr),
            file = row.data();
        if ($(e.currentTarget).prop('checked')) {
            this.model.files.push(file);
        }
        else {
            this.model.files = _.without(this.model.files, file);
        }

        this.manageSelectAllButtonState();
        this.$('.order-selected-file-count').text(this.model.files.length);
        this.$('.step-1-continue').attr('disabled', !_.size(this.model.files) > 0);
    },
    countryChanged: function () {
        let country = this.model.get('billingCountry') && this.model.get('billingCountry').length > 0 ? this.model.get('billingCountry').toLowerCase() : 'us',
            options = '<option value="">Select Value</option>';
        _.each(PJQ.constants.states[country], function (state) {
            options += '<option value="' + state.abbreviation.toLowerCase() + '">' + state.name + '</option>';
        });
        this.statePicker.$el.html(options);
        this.statePicker.refresh();
        if (this.model.get('billingState'))
            this.statePicker.setValue(this.model.get('billingState').toLowerCase());

        PJQ.helpers.inputHelpers.inputMaskZip(this.$('.contact-edit-zip'), country);
    },
    manageSelectAllButtonState: function() {
        let isSelectAll = true;
        _.each(this.selectedFolderFiles, function(row){
            if(isSelectAll){
                isSelectAll = _.find(this.model.files, function(file){
                    return file.get('entryId') === row.get('entryId')
                }, this) != null
            }
        }, this)

        this.$('.select-all-files').prop('checked', isSelectAll);
    },
    goToStep: function (step) {
        if(step.currentTarget){
            this.step = $(step.currentTarget).data('step')
        }
        else{
            this.step = step;
        }
        let thisStep = $('.step-' + this.step.toString()),
            thisStepHeader = $('.step-header-' + this.step.toString());
        this.$('[class*=step-]').not(thisStep).collapse('hide');
        this.$('[class*=step-header-]').not(thisStepHeader).removeClass('text-primary').addClass('text-dark op-4');
        thisStepHeader.removeClass('text-dark op-4').addClass('text-primary');

        if (this.step === 1) {
            this.$('.order-selected-file-count').parent().removeClass('text-dark op-4').addClass('text-info');
            this.$('.order-selected-contact-count').parent().removeClass('text-info').addClass('text-dark op-4');
        }
        else if (this.step === 2) {
            this.$('.order-selected-file-count').parent().removeClass('text-info').addClass('text-dark op-4');
            this.$('.order-selected-contact-count').parent().removeClass('text-dark op-4').addClass('text-info');
        }
        else if (this.step === 3) {
            this.$('.order-selected-contact-count').parent().removeClass('text-info').addClass('text-dark op-4');

            if(this.model.recipients == null){
                this.model.recipients = new PJQ.collections.contacts.Contacts();
            }
            this.model.recipients.reset(_.map(this.selectedRecipients, function(contact, a, b){
                return new PJQ.models.contacts.Contact({
                    contactId: contact,
                    id: contact
                });
            }, this));
            this.calculateCost();
        }


        // don't hide the footer if the project is offline
        let isOnline = false;
        if(!PJQ.app.session.project){
            isOnline = true;
        }
        else if(PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() !== "busy"){
            isOnline = true;
        }

        this.$('.modal-footer').attr('hidden', this.step !== 3 && isOnline);

        thisStep.collapse('show');
    },
    calculateCost: function () {
        this.model.beforeSave();
        let endpoint = this.model.project != null ? [
            {
                endpoint: 'projects',
                value: this.model.project.get('projectId')
            },
            {
                endpoint: 'orders'
            },
            {
                endpoint: this.mode === PJQ.constants.files.modes.ALT_PRINT ? 'calculatemultiple' : 'calculate'
            }
        ] : [
            {
                endpoint: 'orders'
            },
            {
                endpoint: 'calculate'
            }
        ];

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpoint),
            data: this.model.attributes
        }).post().done(_.bind(function (data) {
            if(this.mode === PJQ.constants.files.modes.ALT_PRINT){
                this.renderCalculatedTotals(data);
            }
            else{
                this.price = data.total * 100;
                this.render();
            }
        }, this)).fail(function (xhr, err, result) {
        });
    },
    renderCalculatedTotals: function(orders) {
        let templateData = {
            orders: orders
        }
        this.renderSubTemplate(false, this.options.subTemplates.orderCalculatedItems, this.$('.calculated-totals'), templateData);
    },
    onCancel: function () {
        this.removeModal();
    },
    onSave: function () {
        let hasError = false;

        if (this.options.isAdmin && this.options.isSelectRecipients) {
            if (_.size(this.model.recipients.models) === 0) {
                hasError = true;
            }
        }
        else if(this.mode === PJQ.constants.files.modes.ALT_PRINT){
            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_PO_REQUIRED)) {
                let $po = this.$('.order-po-number');
                PJQ.helpers.inputHelpers.setInputError($po, true);
                if (_.size(this.model.get('poNumber')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($po, false);
                    hasError = true;
                }
            }
        }
        else{
            let $company = this.$('.contact-edit-company');
            PJQ.helpers.inputHelpers.setInputError($company, true);
            if (_.size($company.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($company, false);
                hasError = true;
            }

            let $contact = this.$('.contact-edit-name');
            PJQ.helpers.inputHelpers.setInputError($contact, true);
            if (_.size($contact.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($contact, false);
                hasError = true;
            }

            let $address1 = this.$('.contact-edit-address-1');
            PJQ.helpers.inputHelpers.setInputError($address1, true);
            if (_.size($address1.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($address1, false);
                hasError = true;
            }

            let $city = this.$('.contact-edit-city');
            PJQ.helpers.inputHelpers.setInputError($city, true);
            if (_.size($city.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($city, false);
                hasError = true;
            }

            let $zip = this.$('.contact-edit-zip');
            PJQ.helpers.inputHelpers.setInputError($zip, true);
            if (_.size($zip.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($zip, false);
                hasError = true;
            }

            let $state = this.$('select.contact-edit-state');
            PJQ.helpers.inputHelpers.setInputError($state, true);
            if (_.size(this.model.get('billingState')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($state, false);
                hasError = true;
            }

            let $country = this.$('select.contact-edit-country');
            PJQ.helpers.inputHelpers.setInputError($country, true);
            if (_.size(this.model.get('billingCountry')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($country, false);
                hasError = true;
            }

            let $email = this.$('.contact-edit-email');
            PJQ.helpers.inputHelpers.setInputError($email, true);
            if (_.size($email.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($email, false);
                hasError = true;
            }

            let $phone = this.$('.contact-edit-phone');
            PJQ.helpers.inputHelpers.setInputError($phone, true);
            if (_.size(this.model.get('billingPhone')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($phone, false);
                hasError = true;
            }
        }

        let $filesError = this.$('.error');
        if (_.size(this.model.files) === 0) {
            this.errorAlert = new PJQ.Alert($filesError, {
                type: 'danger',
                text: 'No files are selected'
            });
            hasError = true;
        }
        else if(this.errorAlert){
            this.errorAlert.destroy();
        }

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_PO_REQUIRED) && this.mode !== PJQ.constants.files.modes.DOWNLOAD) {
            let $po = this.$('.order-po-number');
            PJQ.helpers.inputHelpers.setInputError($po, true);
            if (_.size(this.model.get('poNumber')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($po, false);
                hasError = true;
            }
        }

        if (hasError) {
            this.$('.ordering-error').removeClass('hidden');
        } else {
            this.$('.ordering-error').addClass('hidden');
            this.model.save(null, {
                success: _.bind(function (result) {
                    if (result.get('status') === 'NEW') {
                        PJQ.notifications.notify.successNotify({
                            message: 'Order #' + result.get('orderId') + ' placed successfully'
                        });
                        this.removeModal();

                        if (typeof this.options.onOrderPlaced === 'function') {
                            this.options.onOrderPlaced();
                        }
                    } else {
                        let orderType = this.mode === PJQ.constants.files.modes.DOWNLOAD ? 'Download' : 'OrderPrints';
                        window.location.href = window.location.origin + '/DesktopModules/PanteraModuleGlobal/OrderPayment.aspx?oc=PROJECT_WALLS&o=' + this.model.id + '&ot=' + orderType;
                    }
                }, this)
            });
        }
    }
});

PJQ.models.files.Order = PJQ.models.BaseModel.extend({
    idAttribute: 'orderId',
    endpoint: function () {
        if (this.project != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.project.id
                },
                {
                    endpoint: 'orders'
                }
            ])
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'orders'
            }
        ])
    },
    parse: function (model) {
        if (model == null) {
            return model;
        }

        if (model.project != null) {
            this.project = model.project;
        }

        if (model.files != null) {
            this.files = model.files;
        }

        if (model.recipients != null) {
            this.recipients = model.recipients;
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            entryIds: _.size(this.files) > 0 ? _.map(_.filter(this.files, function (file) {
                if(PJQ.helpers.objectHelpers.refinedType(file, true) === 'backboneModel') {
                    return !file.get('isFolder')
                }
                else{
                    return !file.isFolder
                }
            }), function (file) {
                if(PJQ.helpers.objectHelpers.refinedType(file, true) === 'backboneModel') {
                    return file.get('drawingId') != null ? -file.get('drawingId') : file.get('entryId');
                }
                else{
                    return file.drawingId != null ? -file.drawingId : file.entryId;
                }
            }) : [],
            recipients: this.recipients ? this.recipients.toJSON() : []
        })
    }
});
